import { Injectable } from '@angular/core';
import { IColorMatchingV1, IxellAPIService, IIngredientColorMatchingV1, IResponseColorMatchingV1 } from './api.service';
import { DatePipe } from '@angular/common';

export enum Technologie {
  IXELLTECH = 1,
  OXELIA = 2,
  H2S = 3
}

@Injectable({
  providedIn: 'root'
})
export class ContretypageService {

  colMatching = new IColorMatchingV1();
  techDemande = "";

  private colorMatchingSub: any;

  constructor(private api: IxellAPIService, public datepipe: DatePipe) { }

  exportContretypage(res: IColorMatchingV1) {
    this.colMatching = res;
    this.colorMatchingSub = this.api.getColorMatching(res.colorMatchingID).subscribe(data => {
      this.colMatching = data;
      //var parser, xmlDoc, newEle;
      //this.techDemande = "";
      //let listPaintQuality = this.colMatching.paintQuality.split(",");
      //for (let q in listPaintQuality) {
      //  this.techDemande += Technologie[+listPaintQuality[q]] + ", "
      //}
      //if (this.techDemande.length > 1)
      //  this.techDemande = this.techDemande.substring(0, this.techDemande.length - 2);
      
      //var text = "<DuPont_Exchange_SpoolFile>"
      //  + "<FormHeader>"
      //  //+"<Shaded></Shaded>"
      //  + "<Type>Custom</Type>"
      //  + "</FormHeader>"
      //  + "<FormData>"
      //  + "<DatabaseItems>"
      //  + "<Key>"
      //  + "<UsesLead>0</UsesLead>" // constante ?
      //  + "<CoatCd>" + this.colMatching.response.coatCd + "</CoatCd>"
      //  + "<FinishType>GLS</FinishType>" // constante ?
      //  + "<Quality>" + this.techDemande + "</Quality>"
      //  //+ "<StockCode></StockCode>"
      //  + "<QualityID>" + this.colMatching.qualityId + "</QualityID>" //X028 -> IXELLTECH ? 
      //  + "</Key>"
      //  + "<FormInfo>"
      //  + "<FormulaType>S</FormulaType>"
      //  + "<Revision>0</Revision>" // constante ?
      //  + "<PoorHider>0</PoorHider>" // constante ?
      //  + "<ColChange>" + this.colMatching.response.variante + "</ColChange>"
      //  + "<ValueShade>" + this.colMatching.response.legend + "</ValueShade>"
      //  + "</FormInfo>"
      //  + "<MfInfo>"
      //  + "<MfName>" + this.colMatching.response.brandVehicle + "</MfName>"
      //  + "<ColName>" + this.colMatching.response.designationPainting + "</ColName>"
      //  + "<ColCode>" + this.colMatching.response.codeFormule + "</ColCode>"
      //  + "<StartYr></StartYr>"
      //  + "<EndYr></EndYr>"
      //  + "</MfInfo>"
      //  + "</DatabaseItems>"
      //  + "<JobItems VolumeRequested = '1'>"
      //  + "<startdate>" + this.datepipe.transform(this.colMatching.dateFinish, 'yyyy-MM-dd') + "</startdate>"
      //  + "<starttime>" + this.datepipe.transform(this.colMatching.dateFinish, 'HH:mm:ss') + "</starttime>"
      //  + "</JobItems>"
      //  + "<MixRec>"
      //  + "</MixRec>"
      //  + "</FormData>"
      //  + "</DuPont_Exchange_SpoolFile>";

      //parser = new DOMParser();
      //xmlDoc = parser.parseFromString(text, "text/xml");

      //for (let i = 0; i < this.colMatching.response.ingredients.length; i++) {
      //  newEle = xmlDoc.createElement("Product");
      //  xmlDoc.getElementsByTagName("MixRec")[0].appendChild(newEle);

      //  var attr = document.createAttribute("PlaceHolder");
      //  var ingrPlace = i + 1;
      //  attr.value = "" + ingrPlace;
      //  xmlDoc.getElementsByTagName("Product")[i].setAttributeNode(attr);

      //  var code = xmlDoc.createElement("TintCode");
      //  var name = xmlDoc.createElement("TintName");
      //  var density = xmlDoc.createElement("Density");
      //  var absmass = xmlDoc.createElement("AbsMass");
      //  var type = xmlDoc.createElement("TintType");
      //  var rfu = xmlDoc.createElement("FromRFU"); // RFU Ready For Use

      //  var codeText = xmlDoc.createTextNode(this.colMatching.response.ingredients[i].code);
      //  var nameText = xmlDoc.createTextNode(this.colMatching.response.ingredients[i].name);
      //  var densityText = xmlDoc.createTextNode(this.colMatching.response.ingredients[i].bdensite);
      //  var absmassText = xmlDoc.createTextNode(this.colMatching.response.ingredients[i].quantity);
      //  var typeText;
      //  console.log(this.colMatching.response.ingredients[i].typeprod);
      //  switch (this.colMatching.response.ingredients[i].typeprod) {
      //    // constante ? Non base x_type_prod
      //    case 250: {
      //      typeText = xmlDoc.createTextNode("A");
      //      break;
      //    }
      //    case 1400: {
      //      typeText = xmlDoc.createTextNode("B");
      //      break;
      //    }
      //    case 100: {
      //      typeText = xmlDoc.createTextNode("C");
      //      break;
      //    }
      //    case 300: {
      //      typeText = xmlDoc.createTextNode("N");
      //      break;
      //    }
      //    case 800: {
      //      typeText = xmlDoc.createTextNode("P");
      //      break;
      //    }
      //    case 600: {
      //      typeText = xmlDoc.createTextNode("V");
      //      break;
      //    }
      //    default: {
      //      typeText = xmlDoc.createTextNode("T");
      //      break;
      //    }
      //  }
      //  var rfuText = xmlDoc.createTextNode(0); // Formule n'est pas Ready For Use à la sortie de contretypage == 0
      //  code.appendChild(codeText);
      //  name.appendChild(nameText);
      //  density.appendChild(densityText);
      //  absmass.appendChild(absmassText);
      //  type.appendChild(typeText);
      //  rfu.appendChild(rfuText);

      //  xmlDoc.getElementsByTagName("Product")[i].appendChild(code);
      //  xmlDoc.getElementsByTagName("Product")[i].appendChild(name);
      //  xmlDoc.getElementsByTagName("Product")[i].appendChild(density);
      //  xmlDoc.getElementsByTagName("Product")[i].appendChild(absmass);
      //  xmlDoc.getElementsByTagName("Product")[i].appendChild(type);
      //  xmlDoc.getElementsByTagName("Product")[i].appendChild(rfu);
      //}
      //var s = new XMLSerializer();
      //var xmlString = s.serializeToString(xmlDoc);
      //this.downloadXMLFormule(xmlString, this.colMatching.response.brandVehicle + '_' + this.colMatching.response.codeFormule + '.xml', 'application/xml');

      let couche = 0;
      if (this.colMatching.response.multicouches == 1) {
        couche = 1;
      }
      this.prepareAndDownloadXml(this.colMatching.response, this.colMatching.paintQuality, this.colMatching.qualityId, this.colMatching.dateFinish, couche, this.colMatching.reference);

      if (this.colMatching.response.multicouches == 1) {
        couche++;
        for (var i = 0; i < this.colMatching.response.responseMulti.length; i++) {
          this.prepareAndDownloadXml(this.colMatching.response.responseMulti[i], this.colMatching.paintQuality, this.colMatching.qualityId, this.colMatching.dateFinish, couche, this.colMatching.reference);
          couche++;
        }
      }

    },
      error => {
        console.log(error);
        if (this.colorMatchingSub != null) this.colorMatchingSub.unsubscribe();
      });
  }

  prepareAndDownloadXml(data: IResponseColorMatchingV1, paintQuality: string, qualityId: string, dateFinish: Date, couche: number, reference: string) {
    var parser, xmlDoc, newEle;
    this.techDemande = "";
    let listPaintQuality = paintQuality.split(","); //data.paintQuality.split(",");
    for (let q in listPaintQuality) {
      this.techDemande += Technologie[+listPaintQuality[q]] + ", "
    }
    if (this.techDemande.length > 1)
      this.techDemande = this.techDemande.substring(0, this.techDemande.length - 2);

    var text = "<DuPont_Exchange_SpoolFile>"
      + "<FormHeader>"
      //+"<Shaded></Shaded>"
      + "<Type>Custom</Type>"
      + "</FormHeader>"
      + "<FormData>"
      + "<DatabaseItems>"
      + "<Key>"
      + "<UsesLead>0</UsesLead>" // constante ?
      + "<CoatCd>" + data.coatCd + "</CoatCd>"
      + "<FinishType>GLS</FinishType>" // constante ?
      + "<Quality>" + this.techDemande + "</Quality>"
      //+ "<StockCode></StockCode>"
      + "<QualityID>" + qualityId + "</QualityID>" //X028 -> IXELLTECH ? 
      + "</Key>"
      + "<FormInfo>"
      + "<FormulaType>S</FormulaType>"
      + "<Revision>0</Revision>" // constante ?
      + "<PoorHider>0</PoorHider>" // constante ?
      + "<ColChange>" + data.variante + "</ColChange>"
      + "<ValueShade>" + data.legend + "</ValueShade>"
      + "</FormInfo>"
      + "<MfInfo>"
      + "<MfName>" + data.brandVehicle + "</MfName>"
      + "<ColName>" + data.designationPainting + "</ColName>"
      + "<ColCode>" + data.codeFormule + "</ColCode>"
      + "<StartYr></StartYr>"
      + "<EndYr></EndYr>"
      + "</MfInfo>"
      + "</DatabaseItems>"
      + "<JobItems VolumeRequested = '1'>"
      + "<startdate>" + this.datepipe.transform(dateFinish, 'yyyy-MM-dd') + "</startdate>"
      + "<starttime>" + this.datepipe.transform(dateFinish, 'HH:mm:ss') + "</starttime>"
      + "</JobItems>"
      + "<MixRec>"
      + "</MixRec>"
      + "</FormData>"
      + "</DuPont_Exchange_SpoolFile>";

    parser = new DOMParser();
    xmlDoc = parser.parseFromString(text, "text/xml");

    for (let i = 0; i < data.ingredients.length; i++) {
      newEle = xmlDoc.createElement("Product");
      xmlDoc.getElementsByTagName("MixRec")[0].appendChild(newEle);

      var attr = document.createAttribute("PlaceHolder");
      var ingrPlace = i + 1;
      attr.value = "" + ingrPlace;
      xmlDoc.getElementsByTagName("Product")[i].setAttributeNode(attr);

      var code = xmlDoc.createElement("TintCode");
      var name = xmlDoc.createElement("TintName");
      var density = xmlDoc.createElement("Density");
      var absmass = xmlDoc.createElement("AbsMass");
      var type = xmlDoc.createElement("TintType");
      var rfu = xmlDoc.createElement("FromRFU"); // RFU Ready For Use

      var codeText = xmlDoc.createTextNode(data.ingredients[i].code);
      var nameText = xmlDoc.createTextNode(data.ingredients[i].name);
      var densityText = xmlDoc.createTextNode(data.ingredients[i].bdensite.toString());
      var absmassText = xmlDoc.createTextNode(data.ingredients[i].quantity.toString());
      var typeText;
      console.log(data.ingredients[i].typeprod);
      switch (data.ingredients[i].typeprod) {
        // constante ? Non base x_type_prod
        case 250: {
          typeText = xmlDoc.createTextNode("A");
          break;
        }
        case 1400: {
          typeText = xmlDoc.createTextNode("B");
          break;
        }
        case 100: {
          typeText = xmlDoc.createTextNode("C");
          break;
        }
        case 300: {
          typeText = xmlDoc.createTextNode("N");
          break;
        }
        case 800: {
          typeText = xmlDoc.createTextNode("P");
          break;
        }
        case 600: {
          typeText = xmlDoc.createTextNode("V");
          break;
        }
        default: {
          typeText = xmlDoc.createTextNode("T");
          break;
        }
      }
      var rfuText = xmlDoc.createTextNode(0); // Formule n'est pas Ready For Use à la sortie de contretypage == 0
      code.appendChild(codeText);
      name.appendChild(nameText);
      density.appendChild(densityText);
      absmass.appendChild(absmassText);
      type.appendChild(typeText);
      rfu.appendChild(rfuText);

      xmlDoc.getElementsByTagName("Product")[i].appendChild(code);
      xmlDoc.getElementsByTagName("Product")[i].appendChild(name);
      xmlDoc.getElementsByTagName("Product")[i].appendChild(density);
      xmlDoc.getElementsByTagName("Product")[i].appendChild(absmass);
      xmlDoc.getElementsByTagName("Product")[i].appendChild(type);
      xmlDoc.getElementsByTagName("Product")[i].appendChild(rfu);
    }
    var s = new XMLSerializer();
    var xmlString = s.serializeToString(xmlDoc);
    let couchePos = "";
    if (couche > 0) { couchePos = "_couche_(" + couche + ")"; }

    this.downloadXMLFormule(xmlString, reference + "_" + data.brandVehicle + '_' + data.codeFormule + couchePos + '.xml', 'application/xml');

  }

  downloadXMLFormule(data: string, filename: string, type: string) {
    var file = new Blob([data], { type: type });
    var a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  

}
